'use strict';
import * as $j_java$002elang$002e$002dFloat$0024 from "./java.lang.-Float$.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_java$002emath$002e$002dBig$002dInteger from "./java.math.-Big-Integer.js";
import * as $j_java$002emath$002e$002dConversion$0024 from "./java.math.-Conversion$.js";
import * as $j_scala$002emath$002e$002dBig$002dDecimal from "./scala.math.-Big-Decimal.js";
import * as $j_scala$002emath$002e$002dScala$002dNumeric$002dAny$002dConversions from "./scala.math.-Scala-Numeric-Any-Conversions.js";
var $p;
function $p_s_math_BigInt$__getCached__I__s_math_BigInt($thiz, i) {
  var offset = ((i - $thiz.qK) | 0);
  var n = $thiz.AR.a[offset];
  if ((n === null)) {
    var hi = (i >> 31);
    n = new $c_s_math_BigInt(null, i, hi);
    $thiz.AR.a[offset] = n;
  }
  return n;
}
export { $p_s_math_BigInt$__getCached__I__s_math_BigInt as $p_s_math_BigInt$__getCached__I__s_math_BigInt };
/** @constructor */
function $c_s_math_BigInt$() {
  this.AS = null;
  this.Nq = null;
  this.qK = 0;
  this.tJ = 0;
  this.AR = null;
  this.Nr = null;
  $n_s_math_BigInt$ = this;
  this.AS = $j_java$002emath$002e$002dBig$002dInteger.$m_Ljava_math_BigInteger$().ed(0, (-2147483648));
  this.Nq = new $c_s_math_BigInt(this.AS, 0, (-2147483648));
  this.qK = (-1024);
  this.tJ = 1024;
  this.AR = new ($d_s_math_BigInt.r().C)(((1 + ((this.tJ - this.qK) | 0)) | 0));
  this.Nr = $j_java$002emath$002e$002dBig$002dInteger.$m_Ljava_math_BigInteger$().ed((-1), (-1));
}
export { $c_s_math_BigInt$ as $c_s_math_BigInt$ };
$p = $c_s_math_BigInt$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_s_math_BigInt$;
/** @constructor */
function $h_s_math_BigInt$() {
}
export { $h_s_math_BigInt$ as $h_s_math_BigInt$ };
$h_s_math_BigInt$.prototype = $p;
$p.qS = (function(i) {
  if (((this.qK <= i) && (i <= this.tJ))) {
    return $p_s_math_BigInt$__getCached__I__s_math_BigInt(this, i);
  } else {
    var hi = (i >> 31);
    return this.u0(i, hi);
  }
});
$p.u0 = (function(l_$_lo, l_$_hi) {
  var value = this.qK;
  var hi = (value >> 31);
  if (((hi === l_$_hi) ? ((value >>> 0) <= (l_$_lo >>> 0)) : (hi < l_$_hi))) {
    var value$1 = this.tJ;
    var hi$1 = (value$1 >> 31);
    var $x_1 = ((l_$_hi === hi$1) ? ((l_$_lo >>> 0) <= (value$1 >>> 0)) : (l_$_hi < hi$1));
  } else {
    var $x_1 = false;
  }
  if ($x_1) {
    return $p_s_math_BigInt$__getCached__I__s_math_BigInt(this, l_$_lo);
  } else {
    return (((l_$_lo | ((-2147483648) ^ l_$_hi)) === 0) ? this.Nq : new $c_s_math_BigInt(null, l_$_lo, l_$_hi));
  }
});
$p.O4 = (function(x) {
  return this.Sq($j_java$002emath$002e$002dBig$002dInteger.$ct_Ljava_math_BigInteger__T__(new $j_java$002emath$002e$002dBig$002dInteger.$c_Ljava_math_BigInteger(), x));
});
$p.Sq = (function(x) {
  if (($j_java$002emath$002e$002dBig$002dInteger.$m_Ljava_math_BitLevel$().kO(x) <= 63)) {
    var $x_1 = x.gB();
    var l_$_lo = $x_1.l;
    var l_$_hi = $x_1.h;
    var value = this.qK;
    var hi = (value >> 31);
    if (((hi === l_$_hi) ? ((value >>> 0) <= (l_$_lo >>> 0)) : (hi < l_$_hi))) {
      var value$1 = this.tJ;
      var hi$1 = (value$1 >> 31);
      var $x_2 = ((l_$_hi === hi$1) ? ((l_$_lo >>> 0) <= (value$1 >>> 0)) : (l_$_hi < hi$1));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      return $p_s_math_BigInt$__getCached__I__s_math_BigInt(this, l_$_lo);
    } else {
      return new $c_s_math_BigInt(x, l_$_lo, l_$_hi);
    }
  } else {
    return new $c_s_math_BigInt(x, 0, (-2147483648));
  }
});
var $d_s_math_BigInt$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_s_math_BigInt$, "scala.math.BigInt$", ({
  uM: 1
}));
export { $d_s_math_BigInt$ as $d_s_math_BigInt$ };
var $n_s_math_BigInt$;
function $m_s_math_BigInt$() {
  if ((!$n_s_math_BigInt$)) {
    $n_s_math_BigInt$ = new $c_s_math_BigInt$();
  }
  return $n_s_math_BigInt$;
}
export { $m_s_math_BigInt$ as $m_s_math_BigInt$ };
function $p_s_math_BigInt__longEncoding__Z($thiz) {
  var x_$_lo = $thiz.bx;
  var x_$_hi = $thiz.by;
  return ((x_$_lo | ((-2147483648) ^ x_$_hi)) !== 0);
}
export { $p_s_math_BigInt__longEncoding__Z as $p_s_math_BigInt__longEncoding__Z };
function $p_s_math_BigInt__bitLengthOverflow__Z($thiz) {
  var shifted = $thiz.kN().y9(2147483647);
  return ((shifted.a3 !== 0) && (!shifted.f($m_s_math_BigInt$().Nr)));
}
export { $p_s_math_BigInt__bitLengthOverflow__Z as $p_s_math_BigInt__bitLengthOverflow__Z };
/** @constructor */
function $c_s_math_BigInt(_bigInteger, _long_$_lo, _long_$_hi) {
  this.fe = null;
  this.bx = 0;
  this.by = 0;
  this.fe = _bigInteger;
  this.bx = _long_$_lo;
  this.by = _long_$_hi;
}
export { $c_s_math_BigInt as $c_s_math_BigInt };
$p = $c_s_math_BigInt.prototype = new $j_java$002elang$002e$002dObject.$h_s_math_ScalaNumber();
$p.constructor = $c_s_math_BigInt;
/** @constructor */
function $h_s_math_BigInt() {
}
export { $h_s_math_BigInt as $h_s_math_BigInt };
$h_s_math_BigInt.prototype = $p;
$p.fh = (function(that) {
  return this.Oj(that);
});
$p.kN = (function() {
  var read = this.fe;
  if ((read !== null)) {
    return read;
  } else {
    var lVal_$_lo = this.bx;
    var lVal_$_hi = this.by;
    var write = $j_java$002emath$002e$002dBig$002dInteger.$m_Ljava_math_BigInteger$().ed(lVal_$_lo, lVal_$_hi);
    this.fe = write;
    return write;
  }
});
$p.m = (function() {
  return (this.BS() ? $j_scala$002emath$002e$002dScala$002dNumeric$002dAny$002dConversions.$f_s_math_ScalaNumericAnyConversions__unifiedPrimitiveHashcode__I(this) : $j_java$002elang$002e$002dObject.$m_sr_Statics$().D(this.kN()));
});
$p.f = (function(that) {
  if ((that instanceof $c_s_math_BigInt)) {
    return this.TO(that);
  } else if (false) {
    return that.f(this);
  } else if (((typeof that) === "number")) {
    var x3 = (+that);
    return (this.Vv() && (this.OK() === x3));
  } else if ($j_java$002elang$002e$002dObject.$isFloat(that)) {
    var x2 = Math.fround(that);
    return (this.Vw() && ($j_java$002elang$002e$002dFloat$0024.$m_jl_Float$().PR($j_java$002emath$002e$002dConversion$0024.$m_Ljava_math_Conversion$().rp(this.kN())) === x2));
  } else {
    return (this.BS() && $j_scala$002emath$002e$002dScala$002dNumeric$002dAny$002dConversions.$f_s_math_ScalaNumericAnyConversions__unifiedPrimitiveEquals__O__Z(this, that));
  }
});
$p.Vt = (function() {
  var x_$_lo = this.bx;
  var x_$_hi = this.by;
  if (((x_$_hi === (-1)) ? ((x_$_lo >>> 0) >= 4294967168) : (x_$_hi > (-1)))) {
    var x$1_$_lo = this.bx;
    var x$1_$_hi = this.by;
    return ((x$1_$_hi === 0) ? ((x$1_$_lo >>> 0) <= 127) : (x$1_$_hi < 0));
  } else {
    return false;
  }
});
$p.VA = (function() {
  var x_$_lo = this.bx;
  var x_$_hi = this.by;
  if (((x_$_hi === (-1)) ? ((x_$_lo >>> 0) >= 4294934528) : (x_$_hi > (-1)))) {
    var x$1_$_lo = this.bx;
    var x$1_$_hi = this.by;
    return ((x$1_$_hi === 0) ? ((x$1_$_lo >>> 0) <= 32767) : (x$1_$_hi < 0));
  } else {
    return false;
  }
});
$p.Vu = (function() {
  var x_$_lo = this.bx;
  var x_$_hi = this.by;
  if ((x_$_hi >= 0)) {
    var x$1_$_lo = this.bx;
    var x$1_$_hi = this.by;
    return ((x$1_$_hi === 0) ? ((x$1_$_lo >>> 0) <= 65535) : (x$1_$_hi < 0));
  } else {
    return false;
  }
});
$p.Vx = (function() {
  var x_$_lo = this.bx;
  var x_$_hi = this.by;
  if (((x_$_hi === (-1)) ? ((x_$_lo >>> 0) >= 2147483648) : (x_$_hi > (-1)))) {
    var x$1_$_lo = this.bx;
    var x$1_$_hi = this.by;
    return ((x$1_$_hi === 0) ? ((x$1_$_lo >>> 0) <= 2147483647) : (x$1_$_hi < 0));
  } else {
    return false;
  }
});
$p.BS = (function() {
  return ($p_s_math_BigInt__longEncoding__Z(this) || $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().ig(this.fe, $m_s_math_BigInt$().AS));
});
$p.Vw = (function() {
  var bitLen = this.O6();
  if ((bitLen <= 24)) {
    var $x_1 = true;
  } else {
    var lowest = this.PC();
    var $x_1 = (((bitLen <= 128) && (lowest >= ((bitLen - 24) | 0))) && (lowest < 128));
  }
  if ($x_1) {
    return (!$p_s_math_BigInt__bitLengthOverflow__Z(this));
  } else {
    return false;
  }
});
$p.Vv = (function() {
  var bitLen = this.O6();
  if ((bitLen <= 53)) {
    var $x_1 = true;
  } else {
    var lowest = this.PC();
    var $x_1 = (((bitLen <= 1024) && (lowest >= ((bitLen - 53) | 0))) && (lowest < 1024));
  }
  if ($x_1) {
    return (!$p_s_math_BigInt__bitLengthOverflow__Z(this));
  } else {
    return false;
  }
});
$p.TO = (function(that) {
  if ($p_s_math_BigInt__longEncoding__Z(this)) {
    if ($p_s_math_BigInt__longEncoding__Z(that)) {
      var x_$_lo = this.bx;
      var x_$_hi = this.by;
      var x$1_$_lo = that.bx;
      var x$1_$_hi = that.by;
      return (((x_$_lo ^ x$1_$_lo) | (x_$_hi ^ x$1_$_hi)) === 0);
    } else {
      return false;
    }
  } else {
    return ((!$p_s_math_BigInt__longEncoding__Z(that)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().ig(this.fe, that.fe));
  }
});
$p.Oj = (function(that) {
  if ($p_s_math_BigInt__longEncoding__Z(this)) {
    if ($p_s_math_BigInt__longEncoding__Z(that)) {
      var x_$_lo = this.bx;
      var x_$_hi = this.by;
      var y_$_lo = that.bx;
      var y_$_hi = that.by;
      return ((x_$_hi === y_$_hi) ? ((x_$_lo === y_$_lo) ? 0 : (((x_$_lo >>> 0) < (y_$_lo >>> 0)) ? (-1) : 1)) : ((x_$_hi < y_$_hi) ? (-1) : 1));
    } else {
      var x$proxy2 = that.fe;
      if ((x$proxy2 === null)) {
        $j_java$002elang$002e$002dObject.$m_sr_Scala3RunTime$().cF();
      }
      return ((-x$proxy2.a3) | 0);
    }
  } else if ($p_s_math_BigInt__longEncoding__Z(that)) {
    var x$proxy3 = this.fe;
    if ((x$proxy3 === null)) {
      $j_java$002elang$002e$002dObject.$m_sr_Scala3RunTime$().cF();
    }
    return x$proxy3.a3;
  } else {
    var x$proxy4 = this.fe;
    if ((x$proxy4 === null)) {
      $j_java$002elang$002e$002dObject.$m_sr_Scala3RunTime$().cF();
    }
    return x$proxy4.jl(that.fe);
  }
});
$p.PC = (function() {
  if ($p_s_math_BigInt__longEncoding__Z(this)) {
    var x_$_lo = this.bx;
    var x_$_hi = this.by;
    if (((x_$_lo | x_$_hi) === 0)) {
      return (-1);
    } else {
      var l_$_lo = this.bx;
      var l_$_hi = this.by;
      return ((l_$_lo !== 0) ? ((32 - Math.clz32(((~l_$_lo) & ((l_$_lo - 1) | 0)))) | 0) : ((64 - Math.clz32(((~l_$_hi) & ((l_$_hi - 1) | 0)))) | 0));
    }
  } else {
    return this.kN().P8();
  }
});
$p.O6 = (function() {
  if ($p_s_math_BigInt__longEncoding__Z(this)) {
    var x_$_lo = this.bx;
    var x_$_hi = this.by;
    if ((x_$_hi < 0)) {
      var x$1_$_lo = this.bx;
      var x$1_$_hi = this.by;
      var lo = ((1 + x$1_$_lo) | 0);
      var hi = ((x$1_$_hi + ((lo === 0) | 0)) | 0);
      var lo$1 = ((-lo) | 0);
      var hi$1 = ((((-hi) | 0) - ((lo$1 !== 0) | 0)) | 0);
      return ((64 - ((hi$1 !== 0) ? Math.clz32(hi$1) : ((32 + Math.clz32(lo$1)) | 0))) | 0);
    } else {
      var l_$_lo = this.bx;
      var l_$_hi = this.by;
      return ((64 - ((l_$_hi !== 0) ? Math.clz32(l_$_hi) : ((32 + Math.clz32(l_$_lo)) | 0))) | 0);
    }
  } else {
    var x$proxy7 = this.fe;
    if ((x$proxy7 === null)) {
      $j_java$002elang$002e$002dObject.$m_sr_Scala3RunTime$().cF();
    }
    return $j_java$002emath$002e$002dBig$002dInteger.$m_Ljava_math_BitLevel$().kO(x$proxy7);
  }
});
$p.r5 = (function() {
  return ($p_s_math_BigInt__longEncoding__Z(this) ? $j_java$002elang$002e$002dObject.$s_RTLong__toInt__I__I__I(this.bx, this.by) : this.kN().r5());
});
$p.gB = (function() {
  if ($p_s_math_BigInt__longEncoding__Z(this)) {
    return $j_java$002elang$002e$002dObject.$bL(this.bx, this.by);
  } else {
    var x$proxy8 = this.fe;
    if ((x$proxy8 === null)) {
      $j_java$002elang$002e$002dObject.$m_sr_Scala3RunTime$().cF();
    }
    return x$proxy8.gB();
  }
});
$p.OK = (function() {
  if (this.BS()) {
    var x_$_lo = this.bx;
    var x_$_hi = this.by;
    if ((x_$_hi >= (-2097152))) {
      var x$1_$_lo = this.bx;
      var x$1_$_hi = this.by;
      var $x_1 = ((x$1_$_hi === 2097152) ? (x$1_$_lo === 0) : (x$1_$_hi < 2097152));
    } else {
      var $x_1 = false;
    }
  } else {
    var $x_1 = false;
  }
  if ($x_1) {
    var x$2_$_lo = this.bx;
    var x$2_$_hi = this.by;
    return ((4.294967296E9 * x$2_$_hi) + (x$2_$_lo >>> 0.0));
  } else {
    return $j_java$002elang$002e$002dObject.$m_jl_Double$().xS($j_java$002emath$002e$002dConversion$0024.$m_Ljava_math_Conversion$().rp(this.kN()));
  }
});
$p.b = (function() {
  if ($p_s_math_BigInt__longEncoding__Z(this)) {
    var this$1_$_lo = this.bx;
    var this$1_$_hi = this.by;
    return $j_java$002elang$002e$002dObject.$m_RTLong$().jv(this$1_$_lo, this$1_$_hi);
  } else {
    return ("" + this.fe);
  }
});
$p.ic = (function(that) {
  return this.Oj(that);
});
function $isArrayOf_s_math_BigInt(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.fZ)));
}
export { $isArrayOf_s_math_BigInt as $isArrayOf_s_math_BigInt };
var $d_s_math_BigInt = new $j_java$002elang$002e$002dObject.$TypeData().i($c_s_math_BigInt, "scala.math.BigInt", ({
  fZ: 1,
  g1: 1,
  aA: 1,
  a: 1,
  v7: 1,
  v8: 1,
  j: 1,
  aK: 1
}));
export { $d_s_math_BigInt as $d_s_math_BigInt };
